import {useEffect} from 'react';

export const usePreventPageScrollOnMount = () => {
  useEffect(() => {
    const topScroll = window.pageYOffset || document.documentElement.scrollTop;

    const leftScroll =
      window.pageXOffset || document.documentElement.scrollLeft;

    window.onscroll = () => {
      window.scrollTo(leftScroll, topScroll);
    };

    return () => {
      window.onscroll = () => {};
    };
  }, []);
};
